export type AppLanguage = 'zh' | 'en' | 'vi';

export const LANGUAGE_STORAGE_KEY = 'lang';
export const DEFAULT_LANGUAGE: AppLanguage = 'zh';

export const LANGUAGE_OPTIONS: { value: AppLanguage; label: string }[] = [
  { value: 'zh', label: '中文' },
  { value: 'en', label: 'English' },
  { value: 'vi', label: 'Tiếng Việt' }
];

export function normalizeLanguage(lang?: string | null): AppLanguage {
  const value = (lang ?? '').toLowerCase();
  if (value === 'vn' || value.startsWith('vi')) return 'vi';
  if (value.startsWith('en')) return 'en';
  if (value.startsWith('zh')) return 'zh';
  return DEFAULT_LANGUAGE;
}

export function getCurrentLanguage(): AppLanguage {
  try {
    return normalizeLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY));
  } catch {
    return DEFAULT_LANGUAGE;
  }
}
